import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

export function ExitPage() {
  // Redirect away from the site after a short delay.
  useEffect(() => {
    const t = setTimeout(() => {
      window.location.replace("https://www.google.com");
    }, 3000);
    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <Helmet>
        <title>Exiting…</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="min-h-screen bg-surface-0 flex items-center justify-center p-6">
        <div className="text-center">
          <p className="text-zinc-400">Redirecting you away from this page…</p>
        </div>
      </div>
    </>
  );
}
